// Module
var code = `<div appHeaderBar><header-bar-title>Privacy Policy</header-bar-title></div>
<app-page-content class="privacy-policy" [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text">Privacy Policy</h1>
        </div>
        <div class="HOA-container__content HOA-container__content--legal">
            <p>CIT Group Inc. and its Affiliates (as defined below) (collectively "CIT," "we," "us," or "our")
                respect your privacy and are committed to treating and using Personal Information (as defined below)
                about you responsibly.</p>
            <h2 id="P13_405">I. ABOUT THIS PRIVACY STATEMENT</h2>
            <p>This Privacy Statement (<strong>"Statement"</strong>) explains how CIT collects, uses and shares
                Personal Information, from or about you in connection with CIT products and services, as well as
                when you use CIT’s websites or mobile applications that link
                to this Statement (each, a <strong>“Site”</strong>, and collectively, <strong>“Sites”</strong>).</p>
            <p>Throughout this Statement, we refer to <strong>"Personal Information"</strong>, which means
                information that identifies, relates to, describes, is capable of being associated with, or could be
                reasonably linked, directly or indirectly, with you or your
                household. Personal Information does not include <strong>Public Information</strong> (for example,
                information from federal, state or local government records), <strong>Aggregated
                    Information</strong> (information relating to multiple individuals
                that has been combined and grouped together, resulting in a data set that contains no personal
                information) or <strong>De-identified Information</strong> (information that is not attributable to
                an identified or identifiable individual).</p>
            <p>This Statement also describes certain rights that California Consumers have under the California
                Consumer Privacy Act of 2018 (<strong>“CCPA”</strong>) with respect to their Personal Information. A
                “California Consumer” is a natural person who resides
                in California. For further information, please reference the “VI. CALIFORNIA
                    CONSUMER PRIVACY ACT – RIGHTS FOR CALIFORNIA CONSUMERS” on page 4.</p>
            <p>If you are an individual and have a CIT financial product or service for your personal, family or
                household purposes, please see our <a (click)="openUrl('https://www.cit.com/uploadedFiles/citcom/contents/footer/CIT-Consumer-Privacy-Notice.pdf')"
                        >CIT Consumer Privacy Notice</a> for additional details about how we use and
                share Personal Information that we collect in connection with providing you those financial products
                or services.</p>
            <p>CIT operates general audience Sites that are accessible to the public. Our Sites are not intended for
                children under 16 years of age. We do not knowingly market our products or services to children, nor
                do we knowingly collect or sell Personal Information
                from children under 16 years of age.</p>
            <h2 id="P21_1765">II. HOW WE COLLECT, USE AND SHARE PERSONAL INFORMATION</h2>
            <h3>How we collect Personal Information</h3>
            <p>The types of Personal Information we collect depends on your interaction with us, including the types
                of products or services you applied for or use. We, or entities that we contract with to provide
                services to support our business and delivery of our
                products and services (<strong>“Service Providers”</strong>), may collect Personal Information:</p>
            <ul class="bullet">
                <li>Directly from you, such as when you apply for or obtain one of our products or services, or if
                    you apply for a job with CIT;
                </li>
                <li>From financial and non-financial companies related by common ownership or control (our <strong>“Affiliates”</strong>),
                    based on your relationship with them and as permitted by law; and/or
                </li>
                <li>From other entities that we work with who are not Service Providers (<strong>“Third
                    Parties”</strong>), such as credit bureaus.
                </li>
            </ul>
            <p>We (or our Service Providers) may also collect Online Information, such as IP address, browser or
                device information, or other information about you indirectly through interactions with our Sites or
                ads, such as:</p>
            <ul class="bullet">
                <li>The types of devices you use to visit our Sites and interact with us;</li>
                <li>Your device’s browsing history on our Sites;</li>
                <li>Information about the ads or content from us (or our service providers) that you view, access or
                    click on; or
                </li>
                <li>The location of the device you use to visit our Sites (with your consent)</li>
            </ul>
            <p>Though Online Information may not, alone, reveal your specific identity, some of this information may
                be used or associated with Personal Information, or may itself be considered Personal Information.
                Please see Section III for more information.</p>
            <h3>How we use Personal Information</h3>
            <p>We (or our Service Providers) may use Personal Information for the following business purposes:</p>
            <ul class="bullet">
                <li>To deliver products, information, or services, that you may request, including to:
                    <ul>
                        <li>complete transactions;</li>
                        <li>provide account services;</li>
                        <li>recognize and remember you when you visit our Sites;</li>
                        <li>improve our Sites and make them easier to use;</li>
                        <li>notify you about updates to your accounts, products, and/or services;</li>
                        <li>perform quality assurance activities that maintain the quality of services provided to
                            you; or
                        </li>
                        <li>respond to your inquiries.</li>
                    </ul>
                </li>
                <li>To provide advertising about our products and services including:
                    <ul>
                        <li>sending marketing materials inclusive of special offers, email notifications, or other
                            notices regarding CIT’s products, services, or news; or
                        </li>
                        <li>presenting personalized content or tailored ads that may relate to your interests and/or
                            location.
                        </li>
                    </ul>
                </li>
                <li>To manage security risks and prevent fraudulent activity, including to:
                    <ul>
                        <li>detect security incidents and protect against malicious, deceptive, fraudulent, or
                            illegal activities;
                        </li>
                        <li>debug to identify and repair errors that may impair existing intended functionality;
                        </li>
                        <li>verify your identity such as when you apply for an account or access our online/mobile
                            services; or
                        </li>
                        <li>assess your creditworthiness, including obtaining credit reports if you apply for credit
                            or apply for a financial product or service.
                        </li>
                    </ul>
                </li>
                <li>To conduct employment-related activities at CIT, including to:
                    <ul>
                        <li>perform background checks;</li>
                        <li>deliver employee benefits programs; or</li>
                        <li>contact references you provide during your application process.</li>
                    </ul>
                </li>
                <li>To perform other activities, as permitted or required by law including:
                    <ul>
                        <li>to perform internal research;</li>
                        <li>in connection with litigation;</li>
                        <li>to comply with regulatory record retention requirements; or</li>
                        <li>for audit purposes within our organization.&emsp;</li>
                    </ul>
                </li>
            </ul>
            <h3>How we share Personal Information</h3>
            <p>We may share your Personal Information, as permitted or required by law with:</p>
            <ul class="bullet">
                <li>CIT Affiliates;</li>
                <li>Service Providers;</li>
                <li>Regulatory authorities or governmental agencies to meet regulatory or legal requirements; or
                </li>
                <li>Third Parties, with your consent or as permitted by law.</li>
            </ul>
            <h2 id="P31_2884">III. ADDITIONAL INFORMATION ABOUT ONLINE INFORMATION</h2>
            <h3>Online Information</h3>
            <p>When you visit or browse our Sites, we may collect Online Information as described in Section II of
                this Statement. The purpose of collecting this information is to improve the effectiveness of our
                Sites and product offerings. The collection of this information
                allows for the compilation of anonymous and Aggregated Information about the usage of our Sites and
                can help us improve your use of our Sites, for example, providing quick login, streamlining site
                navigation and maintaining up-to-date content for
                all users. Should you configure your browser to reject Cookies, you may disable some of our online
                service's features.</p>
            <h3>Online Behavioral Advertising, “Cookies”, and Similar Technologies</h3>
            <p>CIT and our digital Service Providers (e.g. ad network or agency) may use Cookies, mobile advertising
                identifiers, and other information for the purposes of delivering tailored advertising to you on
                other party websites. <strong>“Cookies”</strong> are
                pieces of data stored by your browser and used by web servers to uniquely distinguish your browser
                from all others and remember your browser over time, including preferences and other information. We
                and our Service Providers may also use Web Beacons
                with or without Cookies for various purposes, including analytics and targeting interest-based
                advertising. <strong>“Web Beacons”</strong> are small image files that are loaded when a web page or
                other online resource is processed by your browser
                (including when emails are opened). If you click on one of our ads on another party’s website,
                Cookies may also be used to track the effectiveness of our online advertising and for the purposes
                of delivering ads that may be relevant to you in the
                future.
            </p>
            <h3>Links to Other Sites and Other Privacy Policies</h3>
            <p>Our Sites may contain links to other party websites. When you click on these links, you may be
                providing information, including Personal Information, to the other party, us, or both. CIT has no
                control over the privacy practices or content of these linked
                websites, so we recommend that you carefully review the privacy policies or statements of every
                other party website that you visit.</p>
            <h2 id="P41_3471">IV. CHOICES RELATED TO HOW WE USE PERSONAL INFORMATION</h2>
            <p>You have choices about how we use your information, including what kinds of marketing you want to
                receive from us.</p>
            <p>You can opt-out of having our Service Providers use your web browsing behavior for purposes of
                serving interest-based advertising by opting out <a (click)="openUrl('http://optout.aboutads.info/')">here</a>.
                You may still see some of our untailored ads, but these will
                not be served to you based on your inferred interests or web browsing activity on our online
                services. Please note this opt-out works via Cookies, so if you delete Cookies, use a different
                device, or change web browsers, you will need to opt-out again.</p>
            <p>You can also opt out of receiving marketing offers via email, telephone or direct mail. Every offer
                will include instructions on how to opt out, or if you prefer, please send your opt-out request to
                privacy.questions@cit.com. We will still contact you
                for transactional purposes, such as to service your account or respond to an inquiry.</p>
            <h3>Do-Not-Track-Signals</h3>
            <p>We currently do not employ technology that changes how our servers treat your browser if our servers
                receive a "do-not-track" signal from your browser.</p>
            <h2 id="P55_6514">V. HOW WE PROTECT THE CONFIDENTIALITY AND SECURITY OF YOUR PERSONAL INFORMATION</h2>
            <p>CIT uses reasonable physical, electronic, and procedural safeguards to protect Personal Information
                from unauthorized access, deletion or alteration. As part of our security practices, CIT does not
                send requests for Personal Information to our customers
                via e-mail or texts. Any Personal Information you request CIT to send you via email, such as your
                account balance, is encrypted. However, standard email communications are not. Therefore, you should
                not transmit your Personal Information to us through
                email. Please note that no company can guarantee perfect online security, and please remain careful
                and vigilant in your online activities.</p>
            <h2 id="P57_7288">VI. CALIFORNIA CONSUMER PRIVACY ACT – RIGHTS FOR CALIFORNIA CONSUMERS</h2>
            <p>The CCPA requires us to make certain additional disclosures and provides California Consumers with
                the ability to request additional information about their Personal Information. This section
                explains these rights and describes how California Consumers
                may submit a request to exercise those rights.</p>
            <p>Please note that the rights under the CCPA do not apply to Personal Information collected, processed,
                sold or disclosed pursuant to:</p>
            <ul class="bullet">
                <li>Gramm-Leach-Bliley Act (Public Law 106-102), the federal privacy regulation. Generally, this
                    will apply to any Personal Information obtained in connection with CIT financial products or
                    services that are used primarily for personal, family or household
                    purposes; or
                </li>
                <li>Fair Credit Reporting Act (12 CFR 1022). Generally, this will apply to Personal Information
                    related to credit history or credit worthiness.
                </li>
            </ul>
            <h3>Categories of Personal Information We Collected Recently</h3>
            <p>In the 12-month period prior to the date of this Privacy Statement, CIT or our Service Providers have
                collected the following categories of Personal Information, which we may have shared for a business
                purpose, as permitted or required by law:</p>
            <table cellpadding="0" cellspacing="0" class="CIT-table" dropzone="copy">
                <thead>
                <tr>
                    <th scope="col">Category of Personal Information collected in the previous 12-months</th>
                    <th scope="col" class="HOA-splash--center">Was the Personal Information shared for a business
                        purpose*?
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td >Identifiers, such as a real name, alias, postal address, unique
                        personal identifier, online identifier, Internet Protocol address, email address, account
                        name, social security number, driver’s license number, passport number, or other similar
                        identifiers.
                    </td>
                    <td class="HOA-splash--center">Yes</td>
                </tr>
                </tbody>
                <tbody>
                <tr>
                    <td>Certain, sensitive types of Personal Information, such as gender,
                        age, marital status
                    </td>
                    <td class="HOA-splash--center">Yes – only with our Service Providers to the extent necessary
                        for a business purpose
                    </td>
                </tr>
                <tr>
                    <td>Commercial information, such as records of personal property, products or services
                        purchased
                    </td>
                    <td class="HOA-splash--center">Yes</td>
                </tr>
                <tr>
                    <td>Audio, electronic, visual, thermal, olfactory, or similar information, such as phone
                        recordings; ATM and in-branch video monitoring
                    </td>
                    <td class="HOA-splash--center">Yes</td>
                </tr>
                <tr>
                    <td>Internet or other electronic network activity information, including, but not limited to
                        browsing history, search history, geolocation data (with your consent) and information
                        regarding your interaction with our Sites, collectively <strong>“Online
                            Information”</strong></td>
                    <td class="HOA-splash--center">Yes</td>
                </tr>
                <tr>
                    <td>Professional or employment-related information, such as job title, employer name, or
                        languages
                    </td>
                    <td class="HOA-splash--center">Yes</td>
                </tr>
                <tr>
                    <td>Non-public education information (per the Family Educational Rights
                        and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)), such a school name, number of
                        years attended
                    </td>
                    <td class="HOA-splash--center">Yes – only for applicants of employment and employees</td>
                </tr>
                <tr>
                    <td>Inferences drawn from Personal Information to create a consumer
                        profile that may reflect consumer’s preferences, characteristics, psychological trends,
                        predispositions, behavior, attitudes, intelligence, abilities, and aptitudes
                    </td>
                    <td class="HOA-splash--center">Yes</td>
                </tr>
                </tbody>
            </table>
            <p>
                <small>*For more information on our sharing practices and the related business purposes, please
                    reference Section II of this Privacy Statement above.
                </small>
            </p>
            <h3>Your rights under the CCPA</h3>
            <p>The CCPA grants California Consumers various rights around the Personal Information that is collected
                about them. The rights are explained in further detail below:</p>
            <ul class="bullet none">
                <li><strong>A. Right to Know About Personal Information Collected and/or Disclosed</strong><br>California
                    Consumers have the right to request information about their Personal Information that CIT has
                    collected in the preceding 12 months. Upon our receipt
                    of a verifiable request from you, we will disclose the following information:
                    <br>1) The categories of Personal Information we have collected about you.
                    <br>2) The categories of sources from which the Personal Information was collected.
                    <br>3) The business or commercial purpose for collecting your Personal Information.
                    <br>4) The categories of third parties with whom we share your Personal Information.
                    <br>5) The specific pieces of Personal Information we have collected about you.
                </li>
                <p> The CCPA allows California Consumers to submit a maximum of two (2) requests in any 12-month
                    period.</p>
                <li><strong>B. Right to Request Deletion of Personal Information</strong><br>California Consumers
                    have the right to request that CIT (and any Service Provider) delete any Personal Information
                    about you which we have collected from you. This right to
                    request deletion does not apply to any of your Personal Information that is subject to an
                    exception in the CCPA, for example, where we need to retain the Personal Information to complete
                    a transaction for which the Personal Information was collected,
                    to prevent fraud or to comply with a legal obligation.
                </li>
                <br>
                <li><strong>C. Right to Opt-Out of the Sale of Personal Information</strong><br>CIT does not sell
                    Personal Information and will not sell Personal Information without providing you with prior
                    notice and an opportunity to opt-out, as required by law.
                </li>
                <br>
                <li><strong>D. Right to Non-Discrimination</strong><br>CIT does not discriminate against any
                    California Consumer who exercises any of the rights described above. This includes denying goods
                    or services; charging different prices or rates; or providing
                    a different level of service or quality of goods or services.
                </li>
            </ul>
            <h3>How to Submit a Request</h3>
            <p>California Consumers can submit a request, by either completing the <a
                    (click)="openUrl('https://dataprivacyrights.cit.com/')">Online Request Form</a> or by calling us at
                1-866-206-2711, Monday through Friday from 8:00 a.m. to 4:30 p.m. PST.</p>
            <h3>Submitting a Request through Your Authorized Agent </h3>
            <p>California Consumers have the option to designate an authorized agent to submit a request on their
                behalf. To do this, the authorized agent must select “authorized agent” in the Online Request Form
                and provide all of the required information, along with
                proof of authorization in the form of a <a
                        (click)="openUrl('https://www.cit.com/uploadedFiles/citcom/pages/footer/Privacy/Agent_Authorization_Form_FINAL.pdf')"
                        >notarized authorization form</a>, signed by the California Consumer who is
                the subject of the request.
                We will also contact the California Consumer directly to verify the request.</p>
            <p>We will respond to requests within 45 days and will notify the requester if we need additional
                time.</p>
            <h3>Changes to this Statement</h3>
            <p>This Statement is subject to change. If we make changes to this Statement, we will revise the “Last
                Updated” date at the top of this Statement. Your use of the Site means that you accept the terms of
                this Statement.</p>
            <p>Any dispute related to this Statement will be governed by our <a
                    (click)="openUrl('https://banking.cit.com/sites/banking.cit.com/files/media/cit-web-site-terms-of-use.pdf')">Terms of Use</a>.</p>
            <h3>Contact for More Information</h3>
            <p>If you have questions or concerns about CIT’s privacy practices or this Statement, please email us at
                <a href="mailto:privacy.questions@cit.com">privacy.questions@cit.com</a>.</p>
            <hr>
            <h2><a (click)="openUrl('https://www.cit.com/US-Consumer-Privacy-Notice/')" title="U.S. Consumer Privacy Notice">U.S.
                Consumer Privacy Notice</a></h2>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;